
    import { Loader } from "@googlemaps/js-api-loader";
    const RESIZE_SCREEN = 550; // Defenition for when it is large or small
    const RESIZE_RATIO_LARGE_SCREEN = 1.3;
    const RESIZE_RATIO_SMALL_SCREEN = 1.7;
    const RESIZE_MIN_OFFSET = 40; // We always want to leave some extra space

    export default {
    emits: ['close'],
        data: () => ({
            imageUrl: "" as string,
            panorama: null as google.maps.StreetViewPanorama | null,
        }),
        mounted() {
            const loader = new Loader({
                apiKey: this.$store.getters.getStreetViewKey,
                version: "weekly",
            });

            loader.load().then(async () => {
                const { StreetViewPanorama } = await google.maps.importLibrary("streetView") as google.maps.MapsLibrary;
                const streetViewDiv = document.getElementById("street-view");
                this.panorama = new StreetViewPanorama(
                    streetViewDiv,
                    {
                        position: { lat: this.manValue.lat, lng: this.manValue.lng },
                        pov: { heading: this.manValue.bearing, pitch: 0 },
                        zoom: 1,
                    }
                );
            }).catch(() => this.close());

            // set streetview height
            this.setStreetViewHeight();
            window.addEventListener("resize", this.setStreetViewHeight);
        },

        methods: {
            cleanUp() { // We need to destroy the webgl context manually, otherwise the first webglcontext will be replaced after a while (which is the map)
                const streetViewDiv = document.getElementById("street-view");
                if (!streetViewDiv) {
                    return;
                }

                const canvases = streetViewDiv.getElementsByTagName("canvas");
                for (let canvas of canvases) {
                    const gl = canvas.getContext('webgl');
                    if (gl) {
                        gl.getExtension("WEBGL_lose_context").loseContext();
                    }
                }
                // we als need to cleanup the eventlistener
                window.removeEventListener("resize", this.setStreetViewHeight);

                streetViewDiv.remove();
            },
            setStreetViewHeight() {
                const streetViewWrapper = document.getElementById("street-view-wrapper");
                if (!streetViewWrapper) return;
                streetViewWrapper.style.height = `${window.innerHeight / (window.innerHeight > RESIZE_SCREEN ? RESIZE_RATIO_LARGE_SCREEN : RESIZE_RATIO_SMALL_SCREEN) - RESIZE_MIN_OFFSET}px`; // Set the height based on the screen size;
            },
            close() {
                this.$emit('close', true);
            },
        },

        watch: {
        },

        props: {
            manValue: {
                type: Object,
                required: false,
            },
        },
    }
